import { render, staticRenderFns } from "./AssetsField.vue?vue&type=template&id=fc85761c&scoped=true&"
import script from "./AssetsField.vue?vue&type=script&lang=js&"
export * from "./AssetsField.vue?vue&type=script&lang=js&"
import style0 from "./AssetsField.vue?vue&type=style&index=0&id=fc85761c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc85761c",
  null
  
)

export default component.exports